import { UpIcon } from "../../assets/svgs/UpIcon";

interface Props {
  className?: string;
}
export const ButtonToTopOfPage = ({ className }: Props) => {
  const onButtonClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    // theId.onclick = () => window.scrollTo({top: 0})
  };
  return (
    <div className="flex w-full">
      <button onClick={onButtonClick} className={className}>
        <UpIcon className="text-white hover:opacity-50" />
      </button>
    </div>
  );
};
